import React from 'react';

export default class Page7 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToKnowWhenAndHowToTakeRisks');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Use the tool in this document to highlight your approach to
                                                managing risk. Once you
                                                have established the way you’d assess risk in different
                                                situations write a plan for addressing
                                                any shortcomings.</p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Find opportunities in your current work or elsewhere to practise
                                                assessing situations and making
                                                decisions involving various degrees of risk.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToReframeProblems')}
                                                        className="link_color task button-link-redirect">How to reframe problems</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToFocusOnTheBiggerPicture')}
                                                        className="link_color task button-link-redirect">How to focus on the bigger
                                                        picture</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMakeReasonedJudgements')}
                                                        className="link_color task button-link-redirect">How to make reasoned
                                                        judgements</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBeConfidentInYourJudgementCalls')}
                                                        className="link_color task button-link-redirect">How to be confident in
                                                        making judgement calls</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBalanceRiskWithPotentialBenefits')}
                                                        className="link_color task button-link-redirect">How to balance risk with
                                                        potential benefits</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToUseOptimismToAchieve')}
                                                        className="link_color task button-link-redirect">How to use optimism to
                                                        achieve.</div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>


                                            <ol className="testclass">
                                                <li><p className="further_info_content">Kahneman,
                                                    D. &amp; Tversky, A. (1979). Prospect Theory: An Analysis of
                                                    Decision Making Under Risk.
                                                    <span className="subtiltereg"> Econometrica,</span> 263-291.
                                                </p></li>
                                                <li><p className="further_info_content"> Robbins, S. (1998).
                                                    <span className="subtiltereg">  Organisational Behaviour: Concepts, Controversies and Applications.</span> Prentice
                                                    Hall.</p></li>
                                                <li><p className="further_info_content"> Llewellyn, D. (2003).
                                                    The psychology of risk taking: The case for a
                                                    multidimensional model of risk taking
                                                    behaviour. Paper presented at the 2003 O2 Risk
                                                    Conference.</p></li>
                                                <li><p className="further_info_content"> Kogan, N. and Wallach,
                                                    M. (1964).
                                                    <span className="subtiltereg">Risk Taking: A Study in Cognition and Personality.</span> New
                                                    York:
                                                    Holt, Rinehart &amp; Winston, 256-61.</p></li>

                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page6')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}